import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(20),
    minWidth: '300px',
  },
  infoWidget: {
    minHeight: '160px',
    minWidth: '300px',
    borderRadius: '12px',
    // '#2C9DC910' is exactly `cardAccentBackground`. Same swap already applied
    // to the twin widget in Dashboard/styles.js.
    backgroundColor: theme.palette.custom.cardAccentBackground,
  },
  knowledge: {
    paddingTop: '10px',
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
    padding: '10px',
  },
  knowImg: {
    width: 'auto',
    maxHeight: '90px',
  },
  centerTypo: {
    flexGrow: 1,
    textAlign: 'center',
    padding: '10px',
  },
  actionArea: {
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    paddingBottom: '20px',
  },
  title: {
    flexGrow: 1,
    letterSpacing: '-0.5px',
  },
  // This is the page root (`content` below is dead — the JSX never uses it).
  headerContent: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
  },
}));

export default useStyles;
